import UtilitiesController from './utilities-controller'
import { includes } from 'lodash'

export default class extends UtilitiesController {
  static targets = ['content', 'indicator', 'trigger']

  connect() {
    document.addEventListener('click', this.onExternalClick)
    document.addEventListener('touch', this.onExternalClick)
  }

  disconnect(event) {
    this.close(event);
  }

  onTriggerClick = event => {
    event.preventDefault()
    if (!includes(this.contentTarget.classList, 'hidden')) {
      this.close()
      return
    }
    this.open()
  }

  onExternalClick = event => {
    if (event && (this.contentTarget.contains(event.target) || this.triggerTarget.contains(event.target))) {
      return;
    }

    this.close()
  }
}
